module.exports = __webpack_public_path__ + "94a0852069be720666eec0677bcec6ac.svg";